<template>
  <div class="col-12">
      <div class="card">
          <div class="card-body">
              <SKMatchList />
          </div>
      </div>
  </div>
</template>

<script>
import SKMatchList from '@/components/miracle-deal/SKMatchList.vue';
export default {
  name: 'MyStrikers',
  components: {
    SKMatchList,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>
